import { useApi } from '@/api';
import type { GetTopCategoriesResponse } from '@/api/handlers/resources/sales/responses/GetTopCategoriesResponse';
import type { ApiResponse } from '@/api/handlers/responses/ApiResponse';
import { useQuery } from '@tanstack/react-query';
import { SalesQueryKeys } from './salesQueryKeys';

export type UseTopCategoriesQueryParams = {
    from: string;
    to: string;
};

/**
 * Top-categories query. The `queryKey` carries `from` / `to` so
 * changing the page-level period filter triggers a refetch
 * automatically.
 */
export const useTopCategoriesQuery = (
    params: UseTopCategoriesQueryParams,
    enabled = true,
) => {
    const { apiClient } = useApi();

    return useQuery<ApiResponse<GetTopCategoriesResponse>>({
        queryKey: SalesQueryKeys.topCategories(params.from, params.to),
        queryFn: () =>
            apiClient.sales.getTopCategories({
                from: params.from,
                to: params.to,
            }),
        enabled,
        staleTime: 60_000,
    });
};
